import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../api';
import { Button } from '@mui/material';
import PreOrcamentoProcessos from './PreOrcamentoProcessos';
import ListaPreOrcamentos from './ListaPreOrcamentos';






function PreOrcamentoApp({ setModo, dadosGPD }) {


  
  
const [dadosCabecalho, setDadosCabecalho] = useState({
  cliente: '',
  desenvolvimento: '',
  data: '',
  servico: '',
  fechado: '',
  aberto: '',
  itensProduto: [{ codigo: '', descricao: '', demanda: '' }],
  materiasPrimas: ['']
});

useEffect(() => {
  if (!dadosGPD) return;

  const converterData = (dataIso) => {
    if (!dataIso) return '';
    const [ano, mes, dia] = dataIso.split('-');
    return `${dia}/${mes}/${ano}`;
  };

  setDadosCabecalho({
    cliente: dadosGPD.cliente || '',
    desenvolvimento: dadosGPD.responsavel || '',
    data: converterData(dadosGPD.dataInicio) || '',
    servico: dadosGPD.classificacao || '',
    fechado: dadosGPD.dimensionalFechado || '',
    aberto: dadosGPD.dimensionalAberto || '',
itensProduto: (Array.isArray(dadosGPD.componentes) ? dadosGPD.componentes : []).map(c => ({
  codigo: c.codigoCliente || '',
  descricao: c.descricaoItem || '',
  demanda: c.demanda || ''
})),
materiasPrimas: (Array.isArray(dadosGPD.componentes) ? dadosGPD.componentes : [])
  .map(c => c.materiaPrima || '')
  .filter(mp => mp),
componentes: Array.isArray(dadosGPD.componentes) ? dadosGPD.componentes : []


  });
}, [dadosGPD]);





  const [processosSelecionados, setProcessosSelecionados] = useState([]);

const [modoInterno, setModoInterno] = useState('listagem');
  const [preOrcamentoSelecionado, setPreOrcamentoSelecionado] = useState(null);


  useEffect(() => {
  const carregarDetalhes = async () => {
    if (!preOrcamentoSelecionado?.id) return;

    try {
      const res = await axios.get(`${API_URL}/preorcamento/${preOrcamentoSelecionado.id}`);
      console.log('✅ Dados carregados do backend:', res.data);

      setDadosCabecalho({
        cliente: res.data.cliente || '',
        desenvolvimento: res.data.responsavel || '',
        data: res.data.dataInicio ? res.data.dataInicio.split('T')[0] : '',
        servico: res.data.classificacao || '',
        fechado: res.data.dimensionalFechado || '',
        aberto: res.data.dimensionalAberto || '',
        itensProduto: Array.isArray(res.data.itensProduto) ? res.data.itensProduto.map(i => ({
          codigo: i.codigo || '',
          descricao: i.descricao || '',
          demanda: i.demanda || ''
        })) : [],
        materiasPrimas: Array.isArray(res.data.materiasPrimas) ? res.data.materiasPrimas : [],
        im: res.data.im || '',
        componentes: res.data.componentes || []


      });

    } catch (err) {
      console.error('❌ Erro ao carregar detalhes do pré-orçamento:', err);
      alert('Erro ao buscar detalhes do pré-orçamento.');
    }
  };

  carregarDetalhes();
}, [preOrcamentoSelecionado?.id]);


  if (modoInterno === 'listagem') {
    return (
      <ListaPreOrcamentos
      

onSelecionar={(orcamento) => {
  if (orcamento === 'voltar') {
    setModo('gpd');
  } else {
    setPreOrcamentoSelecionado(orcamento);
    setModoInterno('formulario');
  }
}}

      />
    );

    
  }


const handleSalvar = async () => {
    if (!dadosCabecalho.cliente || !dadosCabecalho.componentes?.length) {
    alert('Campos obrigatórios estão vazios. Verifique o preenchimento.');
    return;
  }

  try {
    const payload = {
      id: preOrcamentoSelecionado?.id || null,
      cliente: dadosCabecalho.cliente,
      descricao: dadosCabecalho.servico,
      data_abertura: dadosCabecalho.data,
      responsavel: dadosCabecalho.desenvolvimento,
      classificacao: dadosCabecalho.servico,
      dimensional_fechado: dadosCabecalho.fechado,
      dimensional_aberto: dadosCabecalho.aberto,
      itensProduto: dadosCabecalho.itensProduto,
      materiasPrimas: dadosCabecalho.materiasPrimas,
      componentes: dadosCabecalho.componentes || [],
      processosSelecionados: processosSelecionados || [],
      im: dadosCabecalho.im || (dadosGPD && dadosGPD.im) || ''
    };


    console.log('✅ Payload que o frontend VAI ENVIAR pro backend:', payload);

    // Se já existir um pré-orçamento selecionado, atualize (PUT), caso contrário, crie um novo (POST)
    let res;
    
    // Verifique se o pré-orçamento selecionado tem um id
if (preOrcamentoSelecionado?.id) {
  // Atualizar o pré-orçamento existente
  res = await axios.put(`${API_URL}/preorcamento/${preOrcamentoSelecionado.id}`, {
  ...payload,
  id: preOrcamentoSelecionado.id // garantir que o ID também vá no body
});

} else {
  // Criar um novo pré-orçamento
  res = await axios.post(`${API_URL}/preorcamento/salvar`, payload);
}


    const id = res.data.id;
    alert('Pré orçamento ' + (preOrcamentoSelecionado?.id ? 'atualizado' : 'criado') + ' com sucesso! ID: ' + id);

    // Fazer um GET para buscar os dados completos após salvar ou atualizar
        const resDetalhes = await axios.get(`${API_URL}/preorcamento/${id}`);
    console.log('✅ Detalhes do pré orçamento:', resDetalhes.data);

    // Atualizar o estado convertendo para o formato de dadosCabecalho
    const dados = resDetalhes.data;
    setDadosCabecalho({
      cliente: dados.cliente || '',
      desenvolvimento: dados.responsavel || '',
      data: dados.dataInicio ? dados.dataInicio.split('T')[0] : '',
      servico: dados.classificacao || '',
      fechado: dados.dimensionalFechado || '',
      aberto: dados.dimensionalAberto || '',
      itensProduto: Array.isArray(dados.itensProduto) ? dados.itensProduto.map(i => ({
        codigo: i.codigo || '',
        descricao: i.descricao || '',
        demanda: i.demanda || ''
      })) : [],
      materiasPrimas: Array.isArray(dados.materiasPrimas) ? dados.materiasPrimas : [],
      componentes: dados.componentes || [],
      im: dados.im || ''
    });


  } catch (err) {
    console.error('Erro ao salvar:', err);

    // Se o backend mandou mensagem de erro específica, exibe ela
    const mensagem = err.response?.data?.erro || 'Erro ao salvar o pré-orçamento';
    alert(mensagem);
  }
};





  return (
    <div style={{ maxWidth: 1200, margin: '20px auto', padding: 20 }}>
<Button
  variant="outlined"
  color="secondary"
  onClick={() => setModoInterno('listagem')}
  sx={{ fontWeight: 600, mb: 3 }}
>
  Voltar para a Lista
</Button>


          <Button
      variant="outlined"
      color="secondary"
      onClick={() => setModo('gpd')}
      sx={{ fontWeight: 600, mb: 3, mx: 2 }}
    >
      Voltar para o GPD
    </Button>

      <div style={{
        border: '2px solid #d00',
        padding: '20px 50px 30px 30px',
        backgroundColor: '#fdf8f8',
        borderRadius: 6,
        marginTop: 20
      }}>
        <h1 style={{
          textAlign: 'center',
          fontSize: '32px',
          fontWeight: 'bold',
          color: '#333',
          marginBottom: 24,
          borderBottom: '2px solid #999',
          paddingBottom: 8
        }}>
          PLANEJAMENTO PARA ORÇAMENTO
        </h1>

        {/* CÓDIGO IMPRAM */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
 <div style={{
  backgroundColor: '#eef2ff',
  border: '2px solid #4f46e5',
  borderRadius: 6,
  padding: '20px 50px 20px 20px',
  minWidth: 300,
  textAlign: 'center'
}}>
  <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 6 }}>Código Impram:</label>
  <input
  type="text"
  value={dadosCabecalho.im || (dadosGPD && dadosGPD.im) || ''}
  readOnly
  style={{
    width: '100%',
    padding: 10,
    fontSize: 16,
    textAlign: 'center',
    border: '1px solid #ccc',
    borderRadius: 4
  }}
/>

</div>

        </div>

        {/* CABEÇALHO */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          columnGap: '20px',
          rowGap: '16px',
        }}>
          <div>
            <label>Cliente:</label><br />
            <input
              type="text"
              value={dadosCabecalho.cliente}
              onChange={(e) => setDadosCabecalho(prev => ({ ...prev, cliente: e.target.value }))}
              style={{ width: '100%', padding: 6 }}
            />
          </div>

          <div>
            <label>Desenvolvimento:</label><br />
            <input
              type="text"
              value={dadosCabecalho.desenvolvimento}
              onChange={(e) => setDadosCabecalho(prev => ({ ...prev, desenvolvimento: e.target.value }))}
              style={{ width: '100%', padding: 6 }}
            />
          </div>

          <div>
            <label>Data:</label><br />
            <input
              type="date"
              value={dadosCabecalho.data}
              onChange={(e) => setDadosCabecalho(prev => ({ ...prev, data: e.target.value }))}
              style={{ width: '100%', padding: 6 }}
            />
          </div>

          <div>
            <label>Classificação:</label><br />
            <input
              type="text"
              value={dadosCabecalho.servico}
              onChange={(e) => setDadosCabecalho(prev => ({ ...prev, servico: e.target.value }))}
              style={{ width: '100%', padding: 6 }}
            />
          </div>

          <div>
            <label>Dimensional Fechado:</label><br />
            <input
              type="text"
              value={dadosCabecalho.fechado}
              onChange={(e) => setDadosCabecalho(prev => ({ ...prev, fechado: e.target.value }))}
              style={{ width: '100%', padding: 6 }}
            />
          </div>

          <div>
            <label>Dimensional Aberto:</label><br />
            <input
              type="text"
              value={dadosCabecalho.aberto}
              onChange={(e) => setDadosCabecalho(prev => ({ ...prev, aberto: e.target.value }))}
              style={{ width: '100%', padding: 6 }}
            />
          </div>
        </div>

{/* ITENS PRODUTO + MATERIA PRIMA UNIFICADO */}
<div style={{ gridColumn: 'span 3', marginTop: 20 }}>
  <label style={{ fontWeight: 600 }}>Dados do Produto:</label>
  {(dadosCabecalho.itensProduto || []).map((item, idx) => (
    <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 8, gap: 8 }}>
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <label style={{ fontSize: 12, fontWeight: 600 }}>Código do Cliente</label>
        <input
          type="text"
          value={item.codigo}
          onChange={(e) => {
            const novos = [...dadosCabecalho.itensProduto];
            novos[idx].codigo = e.target.value;
            setDadosCabecalho(prev => ({ ...prev, itensProduto: novos }));
          }}
          style={{ padding: 6 }}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', flex: 2 }}>
        <label style={{ fontSize: 12, fontWeight: 600 }}>Descrição do Item</label>
        <input
          type="text"
          value={item.descricao}
          onChange={(e) => {
            const novos = [...dadosCabecalho.itensProduto];
            novos[idx].descricao = e.target.value;
            setDadosCabecalho(prev => ({ ...prev, itensProduto: novos }));
          }}
          style={{ padding: 6 }}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', flex: 2 }}>
        <label style={{ fontSize: 12, fontWeight: 600 }}>Matéria Prima</label>
        <input
          type="text"
          value={dadosCabecalho.materiasPrimas?.[idx] || ''}
          onChange={(e) => {
            const novas = [...(dadosCabecalho.materiasPrimas || [])];
            novas[idx] = e.target.value;
            setDadosCabecalho(prev => ({ ...prev, materiasPrimas: novas }));
          }}
          style={{ padding: 6 }}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <label style={{ fontSize: 12, fontWeight: 600 }}>Demanda</label>
        <input
          type="text"
          value={item.demanda}
          onChange={(e) => {
            const novos = [...dadosCabecalho.itensProduto];
            novos[idx].demanda = e.target.value;
            setDadosCabecalho(prev => ({ ...prev, itensProduto: novos }));
          }}
          style={{ padding: 6 }}
        />
      </div>

      <div style={{ marginTop: 16 }}>
        {idx === 0 ? (
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setDadosCabecalho(prev => ({
                ...prev,
                itensProduto: [...prev.itensProduto, { codigo: '', descricao: '', demanda: '' }],
                materiasPrimas: [...(prev.materiasPrimas || []), '']
              }));
            }}
            sx={{ minWidth: 32, padding: '2px 6px' }}
          >
            +
          </Button>
        ) : (
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => {
              const novosItens = dadosCabecalho.itensProduto.filter((_, i) => i !== idx);
              const novasMPs = (dadosCabecalho.materiasPrimas || []).filter((_, i) => i !== idx);
              setDadosCabecalho(prev => ({ ...prev, itensProduto: novosItens, materiasPrimas: novasMPs }));
            }}
            sx={{ minWidth: 32, padding: '2px 6px' }}
          >
            X
          </Button>
        )}
      </div>
    </div>
  ))}
</div>

      </div>

<PreOrcamentoProcessos
  itensProduto={dadosCabecalho.itensProduto}
  materiasPrimas={dadosCabecalho.materiasPrimas}
  componentes={dadosCabecalho.componentes}
  onChangeComponentes={(novos) =>
    setDadosCabecalho(prev => ({ ...prev, componentes: novos }))
  }
/>





      <button
        onClick={handleSalvar}
        style={{
          marginTop: 20,
          backgroundColor: '#28a745',
          color: '#fff',
          padding: '10px 20px',
          border: 'none',
          borderRadius: 6,
          fontSize: 16
        }}
      >
        Salvar Pré Orçamento
      </button>
    </div>
  );
}


export default PreOrcamentoApp;
